import { render } from "./JMUploadImages.vue?vue&type=template&id=2e4ee368&ts=true&lang=pug"
import script from "./JMUploadImages.vue?vue&type=script&lang=ts"
export * from "./JMUploadImages.vue?vue&type=script&lang=ts"

import "./JMUploadImages.vue?vue&type=style&index=0&id=2e4ee368&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__